import {
  GetSnapshot,
  PostSnapshotByPeriodo,
  PutSnapshotEvaluacion,
  DeleteSnapshotEvaluacion,
  GetResumen,
  PutCambiarVendedor,
  PutCambiarPeriodo
} from "../../../reducers/comisionAnualidad";
import * as actions from "../../../actions/comisionAnualidad";
import { Preview } from "../../../../types/IAction";

export interface SnapshotDispatcher {
  clearSnapshot: () => Promise<Preview<void>>;
  getSnapshotByFolioFactura: (
    folioFactura: string,
    page: number,
    size: number
  ) => Promise<Preview<GetSnapshot>>;
  getSnapshotByPeriodo: (
    periodo: string,
    idClub?: number,
    soloContactCenter?: boolean,
    conCambios?: boolean,
    evaluadorModifico?: boolean,
    page?: number,
    size?: number
  ) => Promise<Preview<GetSnapshot>>;
  getSnapshotByAsesor: (
    periodo: string,
    idVendedor: number,
    page: number,
    size: number
  ) => Promise<Preview<GetSnapshot>>;
  postSnapshotByPeriodo: (
    periodo: string
  ) => Promise<Preview<PostSnapshotByPeriodo>>;
  putSnapshotEvaluacion: (
    idCotizacionItem: number,
    actualizacion: any
  ) => Promise<Preview<PutSnapshotEvaluacion>>;
  deleteSnapshotEvaluacion: (
    idCotizacionItem: number
  ) => Promise<Preview<DeleteSnapshotEvaluacion>>;
  clearResumen: () => Promise<Preview<void>>;
  getResumenByPeriodo: (periodo: string) => Promise<Preview<GetResumen>>;
  getResumenByPeriodoAndIdClub: (
    periodo: string,
    idClub: number
  ) => Promise<Preview<GetResumen>>;
  putCambiarVendedor: (
    idCotizacionItem: number,
    request: any
  ) => Promise<Preview<PutCambiarVendedor>>;
  putCambiarPeriodo: (
    idCotizacionItem: number,
    request: any
  ) => Promise<Preview<PutCambiarPeriodo>>;
}

export const snapshotDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => SnapshotDispatcher = dispatch => ({
  clearSnapshot: () => {
    return dispatch(actions.clearSnapshot());
  },
  getSnapshotByFolioFactura: (
    folioFactura: string,
    page: number,
    size: number
  ) => {
    return dispatch(
      actions.getSnapshotByFolioFactura(folioFactura, page, size)
    );
  },
  getSnapshotByPeriodo: (
    periodo: string,
    idClub?: number,
    soloContactCenter?: boolean,
    conCambios?: boolean,
    evaluadorModifico?: boolean,
    page?: number,
    size?: number
  ) => {
    return dispatch(
      actions.getSnapshotByPeriodo(
        periodo,
        idClub,
        soloContactCenter,
        conCambios,
        evaluadorModifico,
        page,
        size
      )
    );
  },
  getSnapshotByAsesor: (
    periodo: string,
    idVendedor: number,
    page: number,
    size: number
  ) => {
    return dispatch(
      actions.getSnapshotByAsesor(periodo, idVendedor, page, size)
    );
  },
  postSnapshotByPeriodo: (periodo: string) => {
    return dispatch(actions.postSnapshotByPeriodo(periodo));
  },
  putSnapshotEvaluacion: (idCotizacionItem: number, actualizacion: any) => {
    return dispatch(
      actions.putSnapshotEvaluacion(idCotizacionItem, actualizacion)
    );
  },
  deleteSnapshotEvaluacion: (idCotizacionItem: number) => {
    return dispatch(actions.deleteSnapshotEvaluacion(idCotizacionItem));
  },
  clearResumen: () => {
    return dispatch(actions.clearResumen());
  },
  getResumenByPeriodo: (periodo: string) => {
    return dispatch(actions.getResumenByPeriodo(periodo));
  },
  getResumenByPeriodoAndIdClub: (periodo: string, idClub: number) => {
    return dispatch(actions.getResumenByPeriodoAndIdClub(periodo, idClub));
  },
  putCambiarVendedor: (idCotizacionItem: number, request: any) => {
    return dispatch(actions.putCambiarVendedor(idCotizacionItem, request));
  },
  putCambiarPeriodo: (idCotizacionItem: number, request: any) => {
    return dispatch(actions.putCambiarPeriodo(idCotizacionItem, request));
  }
});
